//client/reducers/index.js

import { combineReducers } from 'redux'
import { CHANGE_TAB, tabinit, SWITCH_LANGUAGE, Phrases } from '../actions'

//reducers 建立時，state 會有預設值


//Tab 切換
let tabsIntReducers = function (state = tabinit, action){
  switch (action.type){
    case CHANGE_TAB:
      return action.data
    default:
      return state;
  }
}

let defaultLang = 'tw';
let getDefLang = localStorage.getItem('defaultLang');
if(getDefLang){
  switch(getDefLang) {
    case 'en':
      defaultLang = 'en';
      break;
    case 'tw':
      defaultLang = 'tw';
      break;
    default:
      defaultLang = 'tw'
  }
}

let multiLangReducers = function(state = Phrases[defaultLang], action){
  switch (action.type) {
    case SWITCH_LANGUAGE:
      return Phrases[action.language]
    default:
      return state
  }
}

//合併所有reducers成一個 allReducers

const allReducers = combineReducers({
  tabsIntReducers, multiLangReducers
})

export default allReducers


// WEBPACK FOOTER //
// ./src/reducers/index.js